import { createFileRoute } from "@tanstack/react-router";
import { TenantAIModelsConfig } from "@client/components/tenant-settings/ai-models/tenant-ai-models-config";

type ProviderTab = "defaults" | "added" | "available" | "def-management";

function isValidProviderTab(v: unknown): v is ProviderTab {
  return v === "defaults" || v === "added" || v === "available" || v === "def-management";
}

function isValidAiTab(v: unknown): v is "custom" | "system" {
  return v === "custom" || v === "system";
}

export const Route = createFileRoute("/_app/tenant-settings/ai-models")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: isValidAiTab(search.tab) ? search.tab : "custom",
    providerTab: isValidProviderTab(search.providerTab) ? search.providerTab : "defaults",
  }),
  component: TenantAIModelsConfig,
});
